<div class="bg-white custom-hv">
  <div class="container">
    <div class="row justify-content-center mt-4">
      <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
        <img src="assets/images/edu-logo.svg" alt="{{ genericMessage['G0001'] }}" class="img-fluid" />
      </div>
    </div>
    <hr />
    <div class="col-lg-12 col-md-12 col-sm-12 mx-auto pb-5">
      <div class="mt-5">
        <h3 id="registration_heading">Fingerprint Vendor Registration</h3>
      </div>
      <div class="mt-4">
        <form [formGroup]="fingerprintRegistrationForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="email">Email</label>
              <input
                type="email"
                id="email"
                placeholder="Enter Email"
                tabindex="0"
                formControlName="email"
                class="Inputs form-control"
                readonly />
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="firstName">First Name<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                placeholder="Enter First Name"
                tabindex="0"
                id="firstName"
                formControlName="firstName"
                class="Inputs form-control text-capitalize"
                maxlength="30"
                minlength="2"
                required
                (input)="onFirstNameInput($event)"
                (blur)="checkForTrailingSpace($event, 'firstName')"
                [ngClass]="{
                  'is-invalid': fingerprintRegistrationForm.get('firstName')?.touched && fingerprintRegistrationForm.get('firstName')?.invalid
                }" />
              <div
                *ngIf="
                  fingerprintRegistrationForm.get('firstName')?.touched && fingerprintRegistrationForm.get('firstName')?.errors as errors
                ">
                <div role="alert" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0001'] }}</div>
                <div role="alert"
                  *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0002'] }}
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="lastName">Last Name<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="lastName"
                placeholder="Enter Last Name"
                tabindex="0"
                formControlName="lastName"
                class="Inputs form-control text-capitalize"
                maxlength="30"
                minlength="2"
                required
                (input)="onLastNameInput($event)"
                (blur)="checkForTrailingSpace($event, 'lastName')"
                [ngClass]="{
                  'is-invalid': fingerprintRegistrationForm.get('lastName')?.touched && fingerprintRegistrationForm.get('lastName')?.invalid
                }" />
              <div
                *ngIf="fingerprintRegistrationForm.get('lastName')?.touched && fingerprintRegistrationForm.get('lastName')?.errors as errors">
                <div role="alert" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0004'] }}</div>
                <div role="alert" 
                  *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0005'] }}
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="dpsId" class="dashboard-list">
                DPS ID
                <span class="requiredfield text-danger">*</span>
                <span class="ml-1 dpsid-tooltip-icon" style="position:relative;"
                    (mouseenter)="dspIdTooltip = true" (mouseleave)="dspIdTooltip = false"
                    tabindex="0" 
                    role="button"
                    aria-label="DPS ID information"
                    (keydown.enter)="dspIdTooltip = !dspIdTooltip"
                    (keydown.space)="dspIdTooltip = !dspIdTooltip">
                    <span class="material-symbols-outlined f-16">info</span>
                    <span *ngIf="dspIdTooltip" class="material-symbols-outlined inverted-arrow" style="position:absolute; top:-16px;padding: 0; left:50%; transform:translateX(-50%);">arrow_drop_down</span>
                    <div *ngIf="dspIdTooltip" class="dspId-tooltip-box">
                      <div class="dspId-tooltip-polygon"></div>
                      <div role="alert" class="dspId-tooltip-frame" (keypress)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                        {{genericMessage['G0019'] || 'Enter the first 5 digits of the TCN ID.'}}
                      </div>
                    </div>
                  </span>
              </label>
              <input
                type="text"
                id="dpsId"
                placeholder="Enter DPS ID"
                tabindex="0"
                formControlName="dpsId"
                class="Inputs form-control"
                required
                maxlength="5"
                (input)="onDpsIdInput($event)"
                [ngClass]="{
                  'is-invalid': fingerprintRegistrationForm.get('dpsId')?.touched && fingerprintRegistrationForm.get('dpsId')?.invalid
                }" />
              <div *ngIf="fingerprintRegistrationForm.get('dpsId')?.touched && fingerprintRegistrationForm.get('dpsId')?.errors as errors">
                <div role="alert" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0080'] }}</div>
                <div role="alert" *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])" class="text-danger mt-1 err-font">Please enter the first 5 digits of the TCN ID.</div>
                <!-- <div role="alert" *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])" class="text-danger mt-1 err-font">{{ errorMessage['M0064'] }}</div> -->
                <!-- <div role="alert" *ngIf="errors['duplicate']" class="text-danger mt-1 err-font">The DPS ID entered is already on file.</div> -->
              </div>
            </div>
          </div>
          <div class="row mt-lg-3">
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="organization">Organization<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="organization"
                placeholder="Enter organization"
                tabindex="0"
                formControlName="organization"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="60"
                required
                readonly
                (input)="onOrganizationInput($event)"
                (blur)="onFieldBlur($event, 'organization')"
                [ngClass]="{
                  'is-invalid': fingerprintRegistrationForm.get('organization')?.touched && fingerprintRegistrationForm.get('organization')?.invalid
                }" />
              <div
                *ngIf="fingerprintRegistrationForm.get('organization')?.touched && fingerprintRegistrationForm.get('organization')?.errors as errors">
                <div role="alert" *ngIf="errors['required']" class="text-danger mt-1 err-font">Please enter an organization.</div>
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
                <div role="alert" 
                  *ngIf="!errors['required'] && !errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="department">Department</label>
              <input
                type="text"
                id="department"
                placeholder="Enter Department"
                tabindex="0"
                formControlName="department"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="60"
                (input)="ondepartmentInput($event)"
                (blur)="onFieldBlur($event, 'department')"
                [ngClass]="{
                  'is-invalid': fingerprintRegistrationForm.get('department')?.touched && fingerprintRegistrationForm.get('department')?.invalid
                }" />
              <div
                *ngIf="fingerprintRegistrationForm.get('department')?.touched && fingerprintRegistrationForm.get('department')?.errors as errors">
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
                <div role="alert" 
                  *ngIf="!errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
             <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="title">Title</label>
              <input
                type="text"
                id="title"
                name="title"
                autocomplete="organization-title"
                placeholder="Enter Title"
                tabindex="0"
                formControlName="title"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="60"
                (input)="onTitleInput($event)"
                (blur)="onFieldBlur($event, 'title')"
               [ngClass]="{
                  'is-invalid': fingerprintRegistrationForm.get('title')?.touched && fingerprintRegistrationForm.get('title')?.invalid
                }" />
              <div
                *ngIf="fingerprintRegistrationForm.get('title')?.touched && fingerprintRegistrationForm.get('title')?.errors as errors">
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
                <div
                  *ngIf="!errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="streetAddress">Street Address<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="streetAddress"
                placeholder="Enter street Address"
                tabindex="0"
                formControlName="streetAddress"
                class="Inputs form-control text-capitalize"
                minlength="3"
                maxlength="60"
                required
                (input)="onStreetAddressInput($event)"
                (blur)="onFieldBlur($event, 'streetAddress')"
                [ngClass]="{
                  'is-invalid': fingerprintRegistrationForm.get('streetAddress')?.touched && fingerprintRegistrationForm.get('streetAddress')?.invalid
                }" />
              <div
                *ngIf="fingerprintRegistrationForm.get('streetAddress')?.touched && fingerprintRegistrationForm.get('streetAddress')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0018'] }} </div>
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0052'] }}
                </div>
                <div
                  *ngIf="!errors['required'] && !errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0052'] }}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-lg-3">
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="city">City</label>
              <input
                type="text"
                id="city"
                placeholder="Enter City"
                tabindex="0"
                formControlName="city"
                class="Inputs form-control text-capitalize"
                readonly
                />
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="state">State</label>
              <input
                type="text"
                id="state"
                placeholder="Enter State"
                tabindex="0"
                formControlName="state"
                class="Inputs form-control text-capitalize"
                readonly
              />
            </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="zipCode">ZIP Code<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="zipCode"
                placeholder="Enter ZIP Code"
                tabindex="0"
                formControlName="zipCode"
                class="Inputs form-control text-capitalize"
                (blur)="getAddress()"
                (input)="zipCodeFormat($event)"
                 minlength="5"
                maxlength="10"
                required
                [ngClass]="{
                  'is-invalid': fingerprintRegistrationForm.get('zipCode')?.touched && fingerprintRegistrationForm.get('zipCode')?.invalid
                }" />
              <div
                *ngIf="fingerprintRegistrationForm.get('zipCode')?.touched && fingerprintRegistrationForm.get('zipCode')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0022'] }}</div>
                <div *ngIf="errors['allZeros']" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] }}</div>
                <div *ngIf="errors['invalidZipLength']" class="text-danger mt-1 err-font">
                  Zip code must be either 5 digits or 9 digits
                </div>
                <div
                  *ngIf="!errors['required'] && !errors['allZeros'] && !errors['invalidZipLength'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0023'] }}
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="phoneNumber">Phone Number<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="phoneNumber"
                formControlName="phoneNumber"
                class="form-control"
                required
                placeholder="Enter Phone Number"
                tabindex="0"
                (input)="formatPhoneNumber($event)"
                numbersOnly
                [ngClass]="{
                  'is-invalid':
                    fingerprintRegistrationForm.get('phoneNumber')?.touched && fingerprintRegistrationForm.get('phoneNumber')?.invalid
                }" />
              <div
                *ngIf="
                  fingerprintRegistrationForm.get('phoneNumber')?.touched && fingerprintRegistrationForm.get('phoneNumber')?.errors as errors
                ">
                <div role="alert" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0016'] }}</div>
                <div role="alert" *ngIf="!errors['required'] && errors['pattern']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0017'] }}
                </div>
                <div role="alert" *ngIf="errors['invalidDpsId']" class="text-danger mt-1 err-font">{{ errorMessage['M0064'] }}</div>
                <!-- <div role="alert" *ngIf="errors['duplicate']" class="text-danger mt-1 err-font">The phone number entered is already on file.</div> -->
              </div>
            </div>
          </div>
          <div class="row mt-lg-3">
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="extension">Extension</label>
              <input
                type="text"
                id="extension"
                placeholder="Enter Extension"
                tabindex="0"
                formControlName="extension"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="10"
                (input)="onExtensionInput($event)"
               [ngClass]="{
                  'is-invalid': fingerprintRegistrationForm.get('extension')?.touched && fingerprintRegistrationForm.get('extension')?.invalid
                }" />
              <div
                *ngIf="fingerprintRegistrationForm.get('extension')?.touched && fingerprintRegistrationForm.get('extension')?.errors as errors">
                <div role="alert" 
                  *ngIf="(errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-lg-3">
            <div class="form-group">
              <div class="form-check mb-0 pb-0">
                <input type="checkbox" id="input_fp_registration_form_terms" formControlName="terms" class="mb-2 mr-3 check-box" required 
                  aria-required="true"
                  [attr.aria-describedby]="fingerprintRegistrationForm.get('terms')?.touched && fingerprintRegistrationForm.get('terms')?.invalid ? 'terms-error' : null" />
                <label
                  for="input_fp_registration_form_terms"
                  class="form-check-label mb-0"
                  (click)="$event.preventDefault()"
                  (keypress)="$event.preventDefault()">
                  I have read and agree to the
                  <a href="javascript:void(0)" tabindex="0" class="link-pointer" (click)="openTermsAndConditionsModal($event)"><u>User Agreement.</u></a>
                  <span class="requiredfield text-danger">*</span>
                </label>
                
              </div>
              <div *ngIf="fingerprintRegistrationForm.get('terms')?.touched && fingerprintRegistrationForm.get('terms')?.errors as errors" class="form-check mt-0">
                  <div id="terms-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0044'] }}</div>
                </div>
              <div class="form-check mt-2 mr-3 mb-0 pb-0">
                <input type="checkbox" id="input_fp_registration_form_consent" formControlName="consent" class="check-box mb-4 mr-3" required 
                  aria-required="true"
                  [attr.aria-describedby]="fingerprintRegistrationForm.get('consent')?.touched && fingerprintRegistrationForm.get('consent')?.invalid ? 'consent-error' : null" />
                <label
                  for="input_fp_registration_form_consent"
                  class="form-check-label mb-0"
                  (click)="$event.preventDefault()"
                  (keypress)="$event.preventDefault()">
                  I consent to receive emails and SMS messages from the Nevada Department of Education Online Portal for Application and Licensure for account verification and official communications.
                  <span class="requiredfield text-danger">*</span>
                </label>
                
              </div>
              <div *ngIf="fingerprintRegistrationForm.get('consent')?.touched && fingerprintRegistrationForm.get('consent')?.errors as errors" class="form-check mt-0">
                <div id="consent-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0044'] }}</div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row justify-content-end pb-3 mt-2 mr-0 mb-5">
            <div class="d-flex">
              <button type="submit" class="btn btn-primary" [disabled]="fingerprintRegistrationForm.invalid">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-content">
      <div class="d-flex text-black modal-header pl-4 pr-4 mt-3">
        <h5 class="font-18">Terms &amp; conditions</h5>
        <button type="button" class="btn p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span class="material-symbols-outlined"> close </span>
        </button>
      </div>

      <div class="modal-body termscondition"></div>
    </div>
  </ng-template>
</div>

<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()" (keydown.escape)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <button class="modal-close" (click)="closeModal()">
      <i class="fas fa-times"></i>
    </button>
    <div class="modal-body">
      <div class="success-icon">
        <img src="../../../assets/images/cardy-ai/tick logo.png" alt="Success" width="60" height="60" />
      </div>
      <p class="modal-subtitle">{{ toastMessage['T0027'] || 'Registration completed. A confirmation email will be sent to you shortly with further instructions.' }}</p>
    </div>
  </div>
</div>
